import {IOrder} from "../../models/orders/order";
import {TXT} from "../../txtMap/embedded/txt";
import moment from "moment";
import classes from "./orderPaymentStatus.module.css";

export function OrderPaymentStatus({payment,i18n}: {payment:IOrder["payment"];i18n:TXT}) {
    const paid = payment?.status === "approved";
    const offline = !payment?.method || ["cash","card","kaspiInvoice"].includes(payment.method);
    const detail = payment?.isStatusSetManually ? i18n.changed_manually_short()
        : payment?.status === "pending" && !offline ? i18n.payment_waiting()
        : payment?.status === "cancelled" && !offline ? i18n.payment_unsuccessful()
        : payment && !["pending","approved","cancelled"].includes(payment.status) ? i18n.payment_status_unknown() : "";
    const method = payment?.method === "mock" ? i18n.payment_simulated() : payment?.method ? i18n.runOne(payment.method as Exclude<keyof TXT,"runOne">) : "";
    return <div className={classes.payment}>
        <div className={classes.badges}>
            {method && <span className={`tags__payment ${classes.method}`}>{method}</span>}
            <span className={`tags__payment ${paid ? classes.paid : classes.unpaid}`}>{paid ? i18n.paid() : i18n.unpaid()}</span>
        </div>
        {detail && <span className={classes.detail}>{detail}</span>}
        {payment?.completedAt && <span className={classes.detail}>{i18n.payment_updated()} <time dateTime={payment.completedAt}>{moment(payment.completedAt).format("DD.MM.YYYY HH:mm")}</time></span>}
    </div>;
}
